export default "__VITE_ASSET__22d84fd0__"